module.exports = __webpack_public_path__ + "static/media/tick.4e8fb437.svg";